import queryString from 'query-string';

export default function getQueryParam (search) {
	return queryString.parse(search, {arrayFormat: 'comma'});
};
